// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ScheduledMessagePopup-module__font-s-10___ZKCKy {
  font-size: 10px !important;
}

.ScheduledMessagePopup-module__font-s-12___kcMzR {
  font-size: 12px !important;
}

.ScheduledMessagePopup-module__font-s-13___aAuo_ {
  font-size: 13px !important;
}

.ScheduledMessagePopup-module__font-s-14___zaVEX {
  font-size: 14px !important;
}

.ScheduledMessagePopup-module__font-s-15___QvFcr {
  font-size: 15px !important;
}

.ScheduledMessagePopup-module__font-s-16___BKa_o {
  font-size: 16px !important;
}

.ScheduledMessagePopup-module__font-s-18___Y1fI6 {
  font-size: 18px !important;
}

.ScheduledMessagePopup-module__font-s-20___LUv7z {
  font-size: 20px !important;
}

.ScheduledMessagePopup-module__font-s-22___KUXh0 {
  font-size: 22px !important;
}

.ScheduledMessagePopup-module__font-s-28___OStSi {
  font-size: 28px !important;
}

.ScheduledMessagePopup-module__font-w-400___ZbCeL {
  font-weight: 400 !important;
}

.ScheduledMessagePopup-module__font-w-500___HvxYu {
  font-weight: 500 !important;
}

.ScheduledMessagePopup-module__font-w-600___mtpPG {
  font-weight: 600 !important;
}

.ScheduledMessagePopup-module__font-w-700___dkJ0H {
  font-weight: 700 !important;
}

.ScheduledMessagePopup-module__p-5___kZRck {
  padding: 5px !important;
}

.ScheduledMessagePopup-module__p-12___PanLk {
  padding: 12px !important;
}

.ScheduledMessagePopup-module__p-16___o8GNS {
  padding: 16px !important;
}

.ScheduledMessagePopup-module__p-30___BUKiW {
  padding: 30px !important;
}

.ScheduledMessagePopup-module__p-b-0___J0wHN {
  padding-bottom: 0 !important;
}

.ScheduledMessagePopup-module__p-b-5___IdMMR {
  padding-bottom: 5px !important;
}

.ScheduledMessagePopup-module__p-b-10___XawXM {
  padding-bottom: 10px !important;
}

.ScheduledMessagePopup-module__p-b-12___YJzbX {
  padding-bottom: 12px !important;
}

.ScheduledMessagePopup-module__p-b-16____ccV8 {
  padding-bottom: 16px !important;
}

.ScheduledMessagePopup-module__p-b-18___McJ3V {
  padding-bottom: 18px !important;
}

.ScheduledMessagePopup-module__p-b-20___xvjmn {
  padding-bottom: 20px !important;
}

.ScheduledMessagePopup-module__p-b-25___meE2F {
  padding-bottom: 25px !important;
}

.ScheduledMessagePopup-module__p-b-30___pG7u2 {
  padding-bottom: 30px !important;
}

.ScheduledMessagePopup-module__p-b-50___Qwks0 {
  padding-bottom: 50px !important;
}

.ScheduledMessagePopup-module__p-t-0___vi88M {
  padding-top: 0 !important;
}

.ScheduledMessagePopup-module__p-t-12___nvDLV {
  padding-top: 12px !important;
}

.ScheduledMessagePopup-module__p-t-16___zVhI9 {
  padding-top: 16px !important;
}

.ScheduledMessagePopup-module__p-t-18___Ch1nM {
  padding-top: 18px !important;
}

.ScheduledMessagePopup-module__p-t-20___TJGGq {
  padding-top: 20px !important;
}

.ScheduledMessagePopup-module__p-t-30___Nr4Zf {
  padding-top: 30px !important;
}

.ScheduledMessagePopup-module__p-t-40___ChfmP {
  padding-top: 40px !important;
}

.ScheduledMessagePopup-module__p-t-50___UGpGh {
  padding-top: 50px !important;
}

.ScheduledMessagePopup-module__p-l-20___hWHNq {
  padding-left: 20px !important;
}

.ScheduledMessagePopup-module__p-l-30___Kksym {
  padding-left: 30px !important;
}

.ScheduledMessagePopup-module__p-l-40___k1VA2 {
  padding-left: 40px !important;
}

.ScheduledMessagePopup-module__p-r-16___RCOjS {
  padding-right: 16px !important;
}

.ScheduledMessagePopup-module__p-r-20___z1KXa {
  padding-right: 20px !important;
}

.ScheduledMessagePopup-module__p-r-30___cAsgH {
  padding-right: 30px !important;
}

.ScheduledMessagePopup-module__p-r-50___Ib0sm {
  padding-right: 50px !important;
}

.ScheduledMessagePopup-module__p-r-60___n0Pb9 {
  padding-right: 60px !important;
}

.ScheduledMessagePopup-module__m-b-1____P3SH {
  margin-bottom: 1px !important;
}

.ScheduledMessagePopup-module__m-b-2___BUmQG {
  margin-bottom: 2px !important;
}

.ScheduledMessagePopup-module__m-b-6___qLBTn {
  margin-bottom: 6px !important;
}

.ScheduledMessagePopup-module__m-b-8___VfKIO {
  margin-bottom: 8px !important;
}

.ScheduledMessagePopup-module__m-b-10___JJQw9 {
  margin-bottom: 10px !important;
}

.ScheduledMessagePopup-module__m-b-14___RA3sJ {
  margin-bottom: 14px !important;
}

.ScheduledMessagePopup-module__m-b-16___o2Rcb {
  margin-bottom: 16px !important;
}

.ScheduledMessagePopup-module__m-b-20___QFkue {
  margin-bottom: 20px !important;
}

.ScheduledMessagePopup-module__m-b-22___Qw_6a {
  margin-bottom: 22px !important;
}

.ScheduledMessagePopup-module__m-b-24___pn3Wq {
  margin-bottom: 24px !important;
}

.ScheduledMessagePopup-module__m-b-30___Yu7ud {
  margin-bottom: 30px !important;
}

.ScheduledMessagePopup-module__m-b-32___UoQCT {
  margin-bottom: 32px !important;
}

.ScheduledMessagePopup-module__m-b-40___Bhvkr {
  margin-bottom: 40px !important;
}

.ScheduledMessagePopup-module__m-t-2___Dp_mm {
  margin-top: 2px !important;
}

.ScheduledMessagePopup-module__m-t-3___N0PzH {
  margin-top: 3px !important;
}

.ScheduledMessagePopup-module__m-t-4___ecVCz {
  margin-top: 4px !important;
}

.ScheduledMessagePopup-module__m-t-5___jfuN6 {
  margin-top: 5px !important;
}

.ScheduledMessagePopup-module__m-t-8___bBHN4 {
  margin-top: 8px !important;
}

.ScheduledMessagePopup-module__m-t-10___DTjTZ {
  margin-top: 10px !important;
}

.ScheduledMessagePopup-module__m-t-15___zm7ON {
  margin-top: 15px !important;
}

.ScheduledMessagePopup-module__m-t-16___JW_iD {
  margin-top: 16px !important;
}

.ScheduledMessagePopup-module__m-t-20___ZCzlm {
  margin-top: 20px !important;
}

.ScheduledMessagePopup-module__m-t-22___hxfMe {
  margin-top: 22px !important;
}

.ScheduledMessagePopup-module__m-t-30___pl8_8 {
  margin-top: 30px !important;
}

.ScheduledMessagePopup-module__m-t-32___TOH_a {
  margin-top: 32px !important;
}

.ScheduledMessagePopup-module__m-l-auto___II6yc {
  margin-left: auto !important;
}

.ScheduledMessagePopup-module__m-l-4___Hc1xk {
  margin-left: 4px !important;
}

.ScheduledMessagePopup-module__m-l-5___Bsyw2 {
  margin-left: 5px !important;
}

.ScheduledMessagePopup-module__m-l-6___QTGOG {
  margin-left: 6px !important;
}

.ScheduledMessagePopup-module__m-l-8___jzNCP {
  margin-left: 8px !important;
}

.ScheduledMessagePopup-module__m-l-10___kJmmI {
  margin-left: 10px !important;
}

.ScheduledMessagePopup-module__m-l-16___c9_rG {
  margin-left: 16px !important;
}

.ScheduledMessagePopup-module__m-l-20___bjqc7 {
  margin-left: 20px !important;
}

.ScheduledMessagePopup-module__m-l-24___sBoAy {
  margin-left: 24px !important;
}

.ScheduledMessagePopup-module__m-l-30___GRvbj {
  margin-left: 30px !important;
}

.ScheduledMessagePopup-module__m-l-35___kTKnQ {
  margin-left: 35px !important;
}

.ScheduledMessagePopup-module__m-l-40___Mf16N {
  margin-left: 40px !important;
}

.ScheduledMessagePopup-module__m-r-8___WUefq {
  margin-right: 8px !important;
}

.ScheduledMessagePopup-module__m-r-10___DdVu0 {
  margin-right: 10px !important;
}

.ScheduledMessagePopup-module__m-r-16___ZjIk2 {
  margin-right: 16px !important;
}

.ScheduledMessagePopup-module__m-r-20___tY_yL {
  margin-right: 20px !important;
}

.ScheduledMessagePopup-module__m-r-24___pRV6N {
  margin-right: 24px !important;
}

.ScheduledMessagePopup-module__m-r-30___DT0Kt {
  margin-right: 30px !important;
}

.ScheduledMessagePopup-module__m-r-40___pB4KO {
  margin-right: 40px !important;
}

.ScheduledMessagePopup-module__border-r-3___UoxeT {
  border-radius: 3px !important;
}

.ScheduledMessagePopup-module__border-r-4___m57eX {
  border-radius: 4px !important;
}

.ScheduledMessagePopup-module__border-r-6___ymgyQ {
  border-radius: 6px !important;
}

.ScheduledMessagePopup-module__border-r-10___Sgstn {
  border-radius: 10px !important;
}

.ScheduledMessagePopup-module__border-r-12___rS55B {
  border-radius: 12px !important;
}

.ScheduledMessagePopup-module__border-r-16___zSJSE {
  border-radius: 16px !important;
}

.ScheduledMessagePopup-module__border-r-50___m2tUu {
  border-radius: 50% !important;
}

.ScheduledMessagePopup-module__primary-border___om_9V {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.ScheduledMessagePopup-module__primary-border-b___oOqGD {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.ScheduledMessagePopup-module__primary-border-t___dTkka {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.ScheduledMessagePopup-module__primary-border-l___iPlv5 {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.ScheduledMessagePopup-module__primary-border-r___Ba0Xm {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.ScheduledMessagePopup-module__secondary-border___nijAd {
  border: 1px solid #637768;
}

.ScheduledMessagePopup-module__secondary-border-b___lR0VP {
  border-bottom: 1px solid #637768;
}

.ScheduledMessagePopup-module__secondary-border-t___ruQWF {
  border-top: 1px solid #637768;
}

.ScheduledMessagePopup-module__secondary-border-l___KkV2Y {
  border-left: 1px solid #637768;
}

.ScheduledMessagePopup-module__secondary-border-r___EcTAH {
  border-right: 1px solid #637768;
}

.ScheduledMessagePopup-module__gap-0___rEjdV {
  gap: 0 !important;
}

.ScheduledMessagePopup-module__gap-2___pc744 {
  gap: 2px !important;
}

.ScheduledMessagePopup-module__gap-4___bqUb6 {
  gap: 4px !important;
}

.ScheduledMessagePopup-module__gap-5___otXLt {
  gap: 5px !important;
}

.ScheduledMessagePopup-module__gap-6___kMEB4 {
  gap: 6px !important;
}

.ScheduledMessagePopup-module__gap-8___Zluex {
  gap: 8px !important;
}

.ScheduledMessagePopup-module__gap-10___eX6g3 {
  gap: 10px !important;
}

.ScheduledMessagePopup-module__gap-12___lMzFg {
  gap: 12px !important;
}

.ScheduledMessagePopup-module__gap-14___rlGLx {
  gap: 14px !important;
}

.ScheduledMessagePopup-module__gap-16___JchZX {
  gap: 16px !important;
}

.ScheduledMessagePopup-module__gap-18___aNC36 {
  gap: 18px !important;
}

.ScheduledMessagePopup-module__gap-20___dP0VP {
  gap: 20px !important;
}

.ScheduledMessagePopup-module__gap-24___IxJV6 {
  gap: 24px !important;
}

.ScheduledMessagePopup-module__gap-26___FsHcc {
  gap: 26px !important;
}

.ScheduledMessagePopup-module__gap-30___YOP8Y {
  gap: 30px !important;
}

.ScheduledMessagePopup-module__gap-32____VyTC {
  gap: 32px !important;
}

.ScheduledMessagePopup-module__gap-40___vg3xo {
  gap: 40px !important;
}

.ScheduledMessagePopup-module__gap-50___qoT_7 {
  gap: 50px !important;
}

.ScheduledMessagePopup-module__flex-1___XF2pe {
  flex: 1;
}

.ScheduledMessagePopup-module__flex-none___hnrSi {
  flex: none !important;
}

.ScheduledMessagePopup-module__flex-column___mfhUW {
  display: flex;
  flex-direction: column !important;
}

.ScheduledMessagePopup-module__flex-row___KnTaR {
  display: flex;
  flex-direction: row !important;
}

.ScheduledMessagePopup-module__vertically-centered___XsWTR {
  display: flex;
  align-items: center !important;
}

.ScheduledMessagePopup-module__horizontally-centered___KFNmZ {
  display: flex;
  justify-content: center !important;
}

.ScheduledMessagePopup-module__horizontally-end___ZNwZl {
  display: flex;
  justify-content: end !important;
}

.ScheduledMessagePopup-module__vertically-start___PAhkW {
  display: flex;
  align-items: start !important;
}

.ScheduledMessagePopup-module__space-between___nv0If {
  display: flex;
  justify-content: space-between !important;
}

.ScheduledMessagePopup-module__flex-wrap___kgZq1 {
  flex-wrap: wrap !important;
}

.ScheduledMessagePopup-module__height-100___W2tNG {
  height: 100%;
}

.ScheduledMessagePopup-module__width-50___rkTWC {
  width: 50% !important;
}

.ScheduledMessagePopup-module__width-100___DpzKY {
  width: 100%;
}

.ScheduledMessagePopup-module__cursor-pointer___RJrkC {
  cursor: pointer;
}

.ScheduledMessagePopup-module__cursor-not-allowed___cKi7q {
  cursor: not-allowed !important;
}

.ScheduledMessagePopup-module__absolute-centered___yf1tL {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.ScheduledMessagePopup-module__absolute___BNbXP {
  position: absolute;
}

.ScheduledMessagePopup-module__relative___wVnwB {
  position: relative;
}

.ScheduledMessagePopup-module__fixed___bW8qZ {
  position: fixed;
}

.ScheduledMessagePopup-module__visible___X6XyP {
  opacity: 1;
}

.ScheduledMessagePopup-module__invisible___Z7qjn {
  opacity: 0;
}

.ScheduledMessagePopup-module__col-90___fjIz9 {
  width: 90% !important;
}

.ScheduledMessagePopup-module__col-auto___VeWZF {
  width: auto !important;
}

.ScheduledMessagePopup-module__medical-tabs___ATzDL {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.ScheduledMessagePopup-module__medical-table-new___HTe35 {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.ScheduledMessagePopup-module__medical-table-new___HTe35:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.ScheduledMessagePopup-module__medical-table-new___HTe35::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.ScheduledMessagePopup-module__medical-table-new___HTe35::-webkit-scrollbar-track {
  display: none;
}
.ScheduledMessagePopup-module__medical-table-new___HTe35.ScheduledMessagePopup-module__no-pagination___HxsT9 {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.ScheduledMessagePopup-module__medical-table-new___HTe35.ScheduledMessagePopup-module__no-pagination___HxsT9:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.ScheduledMessagePopup-module__medical-table-new___HTe35.ScheduledMessagePopup-module__no-pagination___HxsT9::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.ScheduledMessagePopup-module__medical-table-new___HTe35.ScheduledMessagePopup-module__no-pagination___HxsT9::-webkit-scrollbar-track {
  display: none;
}

.ScheduledMessagePopup-module__medical-table-empty___EM5SF {
  padding: 14px 40px !important;
}

.ScheduledMessagePopup-module__icon-btn___wfJcB {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.ScheduledMessagePopup-module__search-icon___Z9y0p {
  width: 24px;
  height: 24px;
  align-self: center;
}

.ScheduledMessagePopup-module__disable-select___Dkil2 {
  user-select: none;
}

.ScheduledMessagePopup-module__break-word___QZUwB {
  word-break: break-word;
}

.ScheduledMessagePopup-module__popup-clear-btn___kf2Cy {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.ScheduledMessagePopup-module__scroll-m-b-20___KHpE_ {
  scroll-margin-bottom: 20px;
}

.ScheduledMessagePopup-module__grid____aIvD {
  display: grid;
  padding: 25px;
  grid-row-gap: 10px;
}

.ScheduledMessagePopup-module__buttonsContainer___zbJCU {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
  justify-content: end;
  padding: 30px;
  display: flex;
  gap: 16px;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/popups/ScheduledMessagePopup/ScheduledMessagePopup.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,aAAA;EACA,aAAA;EACA,kBAAA;AA8pBF;;AA3pBA;EACE,2CAAA;EACA,oBAAA;EACA,aAAA;EACA,aAAA;EACA,SAAA;AA8pBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.grid {\n  display: grid;\n  padding: 25px;\n  grid-row-gap: 10px;\n}\n\n.buttonsContainer {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n  justify-content: end;\n  padding: 30px;\n  display: flex;\n  gap: 16px;\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `ScheduledMessagePopup-module__font-s-10___ZKCKy`,
	"fontS12": `ScheduledMessagePopup-module__font-s-12___kcMzR`,
	"fontS13": `ScheduledMessagePopup-module__font-s-13___aAuo_`,
	"fontS14": `ScheduledMessagePopup-module__font-s-14___zaVEX`,
	"fontS15": `ScheduledMessagePopup-module__font-s-15___QvFcr`,
	"fontS16": `ScheduledMessagePopup-module__font-s-16___BKa_o`,
	"fontS18": `ScheduledMessagePopup-module__font-s-18___Y1fI6`,
	"fontS20": `ScheduledMessagePopup-module__font-s-20___LUv7z`,
	"fontS22": `ScheduledMessagePopup-module__font-s-22___KUXh0`,
	"fontS28": `ScheduledMessagePopup-module__font-s-28___OStSi`,
	"fontW400": `ScheduledMessagePopup-module__font-w-400___ZbCeL`,
	"fontW500": `ScheduledMessagePopup-module__font-w-500___HvxYu`,
	"fontW600": `ScheduledMessagePopup-module__font-w-600___mtpPG`,
	"fontW700": `ScheduledMessagePopup-module__font-w-700___dkJ0H`,
	"p5": `ScheduledMessagePopup-module__p-5___kZRck`,
	"p12": `ScheduledMessagePopup-module__p-12___PanLk`,
	"p16": `ScheduledMessagePopup-module__p-16___o8GNS`,
	"p30": `ScheduledMessagePopup-module__p-30___BUKiW`,
	"pB0": `ScheduledMessagePopup-module__p-b-0___J0wHN`,
	"pB5": `ScheduledMessagePopup-module__p-b-5___IdMMR`,
	"pB10": `ScheduledMessagePopup-module__p-b-10___XawXM`,
	"pB12": `ScheduledMessagePopup-module__p-b-12___YJzbX`,
	"pB16": `ScheduledMessagePopup-module__p-b-16____ccV8`,
	"pB18": `ScheduledMessagePopup-module__p-b-18___McJ3V`,
	"pB20": `ScheduledMessagePopup-module__p-b-20___xvjmn`,
	"pB25": `ScheduledMessagePopup-module__p-b-25___meE2F`,
	"pB30": `ScheduledMessagePopup-module__p-b-30___pG7u2`,
	"pB50": `ScheduledMessagePopup-module__p-b-50___Qwks0`,
	"pT0": `ScheduledMessagePopup-module__p-t-0___vi88M`,
	"pT12": `ScheduledMessagePopup-module__p-t-12___nvDLV`,
	"pT16": `ScheduledMessagePopup-module__p-t-16___zVhI9`,
	"pT18": `ScheduledMessagePopup-module__p-t-18___Ch1nM`,
	"pT20": `ScheduledMessagePopup-module__p-t-20___TJGGq`,
	"pT30": `ScheduledMessagePopup-module__p-t-30___Nr4Zf`,
	"pT40": `ScheduledMessagePopup-module__p-t-40___ChfmP`,
	"pT50": `ScheduledMessagePopup-module__p-t-50___UGpGh`,
	"pL20": `ScheduledMessagePopup-module__p-l-20___hWHNq`,
	"pL30": `ScheduledMessagePopup-module__p-l-30___Kksym`,
	"pL40": `ScheduledMessagePopup-module__p-l-40___k1VA2`,
	"pR16": `ScheduledMessagePopup-module__p-r-16___RCOjS`,
	"pR20": `ScheduledMessagePopup-module__p-r-20___z1KXa`,
	"pR30": `ScheduledMessagePopup-module__p-r-30___cAsgH`,
	"pR50": `ScheduledMessagePopup-module__p-r-50___Ib0sm`,
	"pR60": `ScheduledMessagePopup-module__p-r-60___n0Pb9`,
	"mB1": `ScheduledMessagePopup-module__m-b-1____P3SH`,
	"mB2": `ScheduledMessagePopup-module__m-b-2___BUmQG`,
	"mB6": `ScheduledMessagePopup-module__m-b-6___qLBTn`,
	"mB8": `ScheduledMessagePopup-module__m-b-8___VfKIO`,
	"mB10": `ScheduledMessagePopup-module__m-b-10___JJQw9`,
	"mB14": `ScheduledMessagePopup-module__m-b-14___RA3sJ`,
	"mB16": `ScheduledMessagePopup-module__m-b-16___o2Rcb`,
	"mB20": `ScheduledMessagePopup-module__m-b-20___QFkue`,
	"mB22": `ScheduledMessagePopup-module__m-b-22___Qw_6a`,
	"mB24": `ScheduledMessagePopup-module__m-b-24___pn3Wq`,
	"mB30": `ScheduledMessagePopup-module__m-b-30___Yu7ud`,
	"mB32": `ScheduledMessagePopup-module__m-b-32___UoQCT`,
	"mB40": `ScheduledMessagePopup-module__m-b-40___Bhvkr`,
	"mT2": `ScheduledMessagePopup-module__m-t-2___Dp_mm`,
	"mT3": `ScheduledMessagePopup-module__m-t-3___N0PzH`,
	"mT4": `ScheduledMessagePopup-module__m-t-4___ecVCz`,
	"mT5": `ScheduledMessagePopup-module__m-t-5___jfuN6`,
	"mT8": `ScheduledMessagePopup-module__m-t-8___bBHN4`,
	"mT10": `ScheduledMessagePopup-module__m-t-10___DTjTZ`,
	"mT15": `ScheduledMessagePopup-module__m-t-15___zm7ON`,
	"mT16": `ScheduledMessagePopup-module__m-t-16___JW_iD`,
	"mT20": `ScheduledMessagePopup-module__m-t-20___ZCzlm`,
	"mT22": `ScheduledMessagePopup-module__m-t-22___hxfMe`,
	"mT30": `ScheduledMessagePopup-module__m-t-30___pl8_8`,
	"mT32": `ScheduledMessagePopup-module__m-t-32___TOH_a`,
	"mLAuto": `ScheduledMessagePopup-module__m-l-auto___II6yc`,
	"mL4": `ScheduledMessagePopup-module__m-l-4___Hc1xk`,
	"mL5": `ScheduledMessagePopup-module__m-l-5___Bsyw2`,
	"mL6": `ScheduledMessagePopup-module__m-l-6___QTGOG`,
	"mL8": `ScheduledMessagePopup-module__m-l-8___jzNCP`,
	"mL10": `ScheduledMessagePopup-module__m-l-10___kJmmI`,
	"mL16": `ScheduledMessagePopup-module__m-l-16___c9_rG`,
	"mL20": `ScheduledMessagePopup-module__m-l-20___bjqc7`,
	"mL24": `ScheduledMessagePopup-module__m-l-24___sBoAy`,
	"mL30": `ScheduledMessagePopup-module__m-l-30___GRvbj`,
	"mL35": `ScheduledMessagePopup-module__m-l-35___kTKnQ`,
	"mL40": `ScheduledMessagePopup-module__m-l-40___Mf16N`,
	"mR8": `ScheduledMessagePopup-module__m-r-8___WUefq`,
	"mR10": `ScheduledMessagePopup-module__m-r-10___DdVu0`,
	"mR16": `ScheduledMessagePopup-module__m-r-16___ZjIk2`,
	"mR20": `ScheduledMessagePopup-module__m-r-20___tY_yL`,
	"mR24": `ScheduledMessagePopup-module__m-r-24___pRV6N`,
	"mR30": `ScheduledMessagePopup-module__m-r-30___DT0Kt`,
	"mR40": `ScheduledMessagePopup-module__m-r-40___pB4KO`,
	"borderR3": `ScheduledMessagePopup-module__border-r-3___UoxeT`,
	"borderR4": `ScheduledMessagePopup-module__border-r-4___m57eX`,
	"borderR6": `ScheduledMessagePopup-module__border-r-6___ymgyQ`,
	"borderR10": `ScheduledMessagePopup-module__border-r-10___Sgstn`,
	"borderR12": `ScheduledMessagePopup-module__border-r-12___rS55B`,
	"borderR16": `ScheduledMessagePopup-module__border-r-16___zSJSE`,
	"borderR50": `ScheduledMessagePopup-module__border-r-50___m2tUu`,
	"primaryBorder": `ScheduledMessagePopup-module__primary-border___om_9V`,
	"primaryBorderB": `ScheduledMessagePopup-module__primary-border-b___oOqGD`,
	"primaryBorderT": `ScheduledMessagePopup-module__primary-border-t___dTkka`,
	"primaryBorderL": `ScheduledMessagePopup-module__primary-border-l___iPlv5`,
	"primaryBorderR": `ScheduledMessagePopup-module__primary-border-r___Ba0Xm`,
	"secondaryBorder": `ScheduledMessagePopup-module__secondary-border___nijAd`,
	"secondaryBorderB": `ScheduledMessagePopup-module__secondary-border-b___lR0VP`,
	"secondaryBorderT": `ScheduledMessagePopup-module__secondary-border-t___ruQWF`,
	"secondaryBorderL": `ScheduledMessagePopup-module__secondary-border-l___KkV2Y`,
	"secondaryBorderR": `ScheduledMessagePopup-module__secondary-border-r___EcTAH`,
	"gap0": `ScheduledMessagePopup-module__gap-0___rEjdV`,
	"gap2": `ScheduledMessagePopup-module__gap-2___pc744`,
	"gap4": `ScheduledMessagePopup-module__gap-4___bqUb6`,
	"gap5": `ScheduledMessagePopup-module__gap-5___otXLt`,
	"gap6": `ScheduledMessagePopup-module__gap-6___kMEB4`,
	"gap8": `ScheduledMessagePopup-module__gap-8___Zluex`,
	"gap10": `ScheduledMessagePopup-module__gap-10___eX6g3`,
	"gap12": `ScheduledMessagePopup-module__gap-12___lMzFg`,
	"gap14": `ScheduledMessagePopup-module__gap-14___rlGLx`,
	"gap16": `ScheduledMessagePopup-module__gap-16___JchZX`,
	"gap18": `ScheduledMessagePopup-module__gap-18___aNC36`,
	"gap20": `ScheduledMessagePopup-module__gap-20___dP0VP`,
	"gap24": `ScheduledMessagePopup-module__gap-24___IxJV6`,
	"gap26": `ScheduledMessagePopup-module__gap-26___FsHcc`,
	"gap30": `ScheduledMessagePopup-module__gap-30___YOP8Y`,
	"gap32": `ScheduledMessagePopup-module__gap-32____VyTC`,
	"gap40": `ScheduledMessagePopup-module__gap-40___vg3xo`,
	"gap50": `ScheduledMessagePopup-module__gap-50___qoT_7`,
	"flex1": `ScheduledMessagePopup-module__flex-1___XF2pe`,
	"flexNone": `ScheduledMessagePopup-module__flex-none___hnrSi`,
	"flexColumn": `ScheduledMessagePopup-module__flex-column___mfhUW`,
	"flexRow": `ScheduledMessagePopup-module__flex-row___KnTaR`,
	"verticallyCentered": `ScheduledMessagePopup-module__vertically-centered___XsWTR`,
	"horizontallyCentered": `ScheduledMessagePopup-module__horizontally-centered___KFNmZ`,
	"horizontallyEnd": `ScheduledMessagePopup-module__horizontally-end___ZNwZl`,
	"verticallyStart": `ScheduledMessagePopup-module__vertically-start___PAhkW`,
	"spaceBetween": `ScheduledMessagePopup-module__space-between___nv0If`,
	"flexWrap": `ScheduledMessagePopup-module__flex-wrap___kgZq1`,
	"height100": `ScheduledMessagePopup-module__height-100___W2tNG`,
	"width50": `ScheduledMessagePopup-module__width-50___rkTWC`,
	"width100": `ScheduledMessagePopup-module__width-100___DpzKY`,
	"cursorPointer": `ScheduledMessagePopup-module__cursor-pointer___RJrkC`,
	"cursorNotAllowed": `ScheduledMessagePopup-module__cursor-not-allowed___cKi7q`,
	"absoluteCentered": `ScheduledMessagePopup-module__absolute-centered___yf1tL`,
	"absolute": `ScheduledMessagePopup-module__absolute___BNbXP`,
	"relative": `ScheduledMessagePopup-module__relative___wVnwB`,
	"fixed": `ScheduledMessagePopup-module__fixed___bW8qZ`,
	"visible": `ScheduledMessagePopup-module__visible___X6XyP`,
	"invisible": `ScheduledMessagePopup-module__invisible___Z7qjn`,
	"col90": `ScheduledMessagePopup-module__col-90___fjIz9`,
	"colAuto": `ScheduledMessagePopup-module__col-auto___VeWZF`,
	"medicalTabs": `ScheduledMessagePopup-module__medical-tabs___ATzDL`,
	"medicalTableNew": `ScheduledMessagePopup-module__medical-table-new___HTe35`,
	"noPagination": `ScheduledMessagePopup-module__no-pagination___HxsT9`,
	"medicalTableEmpty": `ScheduledMessagePopup-module__medical-table-empty___EM5SF`,
	"iconBtn": `ScheduledMessagePopup-module__icon-btn___wfJcB`,
	"searchIcon": `ScheduledMessagePopup-module__search-icon___Z9y0p`,
	"disableSelect": `ScheduledMessagePopup-module__disable-select___Dkil2`,
	"breakWord": `ScheduledMessagePopup-module__break-word___QZUwB`,
	"popupClearBtn": `ScheduledMessagePopup-module__popup-clear-btn___kf2Cy`,
	"scrollMB20": `ScheduledMessagePopup-module__scroll-m-b-20___KHpE_`,
	"grid": `ScheduledMessagePopup-module__grid____aIvD`,
	"buttonsContainer": `ScheduledMessagePopup-module__buttonsContainer___zbJCU`
};
module.exports = ___CSS_LOADER_EXPORT___;
